import {EditHardwareItem} from "./HwEditingContextProvider";
import {
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Tab, Tabs, Typography
} from "@mui/material";
import {Popover} from "../../../../misc/Popover";
import WarningIcon from "@mui/icons-material/Warning";
import React, {useState} from "react";
import {
    HwOpening,
    warnMissingDegreesPrefix,
    warnNeedElectricStrikeConfig,
    warnRemoveElectricStrikeConfig
} from "../../../../api/Hardware";
import {Close} from "@mui/icons-material";
import {useReloader} from "./ReloadContext";
import Settings from "@mui/icons-material/Settings";
import {tabGroup} from "../../../logistics/purchasing/PartsToSource";
import {TabWrapper} from "../TabWrapper";
import {ConfigureDegrees} from "./configure/ConfigureDegrees";
import {ConfigureElectricStrike} from "./configure/ConfigureElectricStrike";
import {first} from "nate-react-api-helpers";


const categoriesNeedDegrees = [
    "Concealed OH Stop",
    "Concealed OH Holder"
]

export function ConfigureHardwareItemExt(props: {
    value: EditHardwareItem;
    openings: HwOpening[];
}) {
    const [show, setShow] = useState<HTMLButtonElement | null>(null)
    const reloadRef = useReloader();

    const hasESConfig = props.value.electricStrikeConfig.inactiveLeaf || props.value.electricStrikeConfig.activeLeaf;
    const warnings = props.value.warnings || [];
    const needsDegreesConfig = categoriesNeedDegrees.includes(props.value.category);

    const [tab, setTab] = useState("warnings");
    const [reloadOnClose, setReloadOnClose] = useState(false);

    // @ts-ignore
    if(!("id" in props.value) || props.value.id <= 0) return null;
    if(warnings.length === 0 && !hasESConfig && !needsDegreesConfig) return null;

    // @ts-ignore
    const hardwareGroupId = props.value.hardwareGroup;
    const isNeedESConfig = warnings.includes(warnNeedElectricStrikeConfig);
    const isRemoveESConfig = warnings.includes(warnRemoveElectricStrikeConfig);
    const isDegreesConfigWarning = !!warnings.find(w => w.startsWith(warnMissingDegreesPrefix));
    const isPair = first(props.openings.map(o => o.openingType), f => true) === "Pair"

    const showES = isNeedESConfig || isRemoveESConfig || hasESConfig;
    const showDegrees = isDegreesConfigWarning || needsDegreesConfig;

    const onClose = () => {
        setShow(null)
        if(reloadOnClose) reloadRef.current();
    }

    return (
        <>
            {warnings.length > 0 && <IconButton size="small" style={{
                fontSize: "1rem",
            }} onClick={(e) => setShow(e.currentTarget)}>
                <WarningIcon color="error" fontSize="inherit" />
            </IconButton>}
            <IconButton onClick={(e) => setShow(e.currentTarget)} size="small" style={{
                fontSize: "1rem",
            }}>
                <Settings fontSize="inherit" />
            </IconButton>
            {show && <Popover open anchorEl={show} onClose={onClose}>
                <div style={{
                    paddingLeft: 16,
                    paddingTop: 16,
                    display: "flex",
                    gap: 8,
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>
                    <Typography variant="h6">
                        Configure Item
                    </Typography>
                    <IconButton onClick={onClose}>
                        <Close />
                    </IconButton>
                </div>

                <TabWrapper>
                    <Tabs className={tabGroup} value={tab} onChange={(e, value) => {
                        setTab(value)
                    }}>
                        <Tab label="Warnings" value="warnings" />
                        {showDegrees && <Tab label="Degrees" value="degrees" />}
                        {showES && <Tab label="Electric Strike" value="electric-strike" />}
                    </Tabs>
                </TabWrapper>
                {(showDegrees && tab === "degrees") && <ConfigureDegrees
                    hardwareGroupId={hardwareGroupId}
                    isPair={isPair}
                    onUpdate={() => setReloadOnClose(true)}
                />}

                {(showES && tab === "electric-strike") &&
                    <ConfigureElectricStrike
                        value={props.value}
                        isRemoveESConfig={isRemoveESConfig}
                        onUpdate={() => {
                            setShow(null);
                            reloadRef.current();
                        }}
                    />
                }
                {tab === "warnings" && <List dense>
                    {warnings.map((warning, i) => (
                        <ListItem key={i}>
                            <ListItemIcon>
                                <WarningIcon color="error" />
                            </ListItemIcon>
                            <ListItemText primary={warning} />
                        </ListItem>
                    ))}
                    {warnings.length === 0 && <ListItem>
                        <ListItemText primary="No Warnings" />
                    </ListItem>}
                </List>}
            </Popover>}
        </>
    )
}